export const HELP_CENTER = "https://help.peech-ai.com/en/";
export const NEWS_FEED = "https://news.eu.intercom.com/peech";

export const FOOTAGE_PREVIEW_PATH = "preview/dash/footage";
